import { render, staticRenderFns } from "./ImpressaoInteiroTeor.vue?vue&type=template&id=2c764af2&"
import script from "./ImpressaoInteiroTeor.vue?vue&type=script&lang=js&"
export * from "./ImpressaoInteiroTeor.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoInteiroTeor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports